import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorManagementComponent } from './author-management/author-management.component';
import { EditAuthorManagementComponent } from './edit-author-management/edit-author-management.component';

const routes: Routes = [
  { path: '', component: AuthorManagementComponent },
  { path: ':id', component: EditAuthorManagementComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthorManagementRoutingModule {}
